<template>
  <div class="menu-container">
    <div class="menu-item" v-for="(menu,index) in menus" :key="index">
      <div v-if="'children' in menu">
        <div class="menu-sub-item" :class="{active:(menu.nodeId in traceIds)}" @click="$router.push(menu.url)">{{ menu.name }}</div>
        <div class="menu-sub-menu">
          <div class="menu-link" @click="$router.push(subMenu.url)" v-for="(subMenu,subIndex) in menu.children" :key="subIndex" :class="{'active-item':subMenu.nodeId in traceIds}">{{subMenu.name }}</div>
        </div>
      </div>
      <div v-else>
        <div class="menu-sub-item" @click="$router.push(menu.url)" :class="{active:menu.nodeId in traceIds}">{{ menu.name }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['menus', 'selectTrace'],
  computed: {
    traceIds: function () {
      let ids = {}
      for (var i in this.selectTrace) {
        ids[this.selectTrace[i].nodeId] = 1
      }
      return ids
    }
  }
}
</script>
<style scoped>
.menu-container {
  width: 100%;
  background: #ffffff;
  border-top: #018FD7 solid 24px;
}
.menu-sub-item {
  padding: 12px 20px;
  background: #DCE6EF;
  cursor: pointer;
  font-size: 14px;
  color: #515151;
  border-top: solid 1px #ffffff;
}
.menu-sub-menu {
  display: none;
}
.menu-link {
  padding: 6px 20px;
  cursor: pointer;
  font-size:14px;
  color: #515151;
}
.active {
  background:#018FD7;
  color:#ffffff;
}
.active-item {
    background:#129fe8;
  color:#ffffff;
}
.active + .menu-sub-menu {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/widgets/public/SubLeftMenu.vue